import { Guid } from "../../../../../Engine/Types/Guid";
import { fiasConvertationMethods, fiasConvertationToShowMethods } from "../Utils/Convertations/Types";

export interface ParsedExtendedFiasField {
    sourceValue: FiasSourceValue[];
    path: string;
    type: FiasExtendFieldsType;
    display: boolean;
    description: string;
    parentGuid?: string;
    optional: boolean;
    setToModel: boolean;
    endComma: boolean;
    prefix?: string;
    showInModal: boolean;
    convertToShow?: fiasConvertationToShowMethods;
    child: boolean;
    clearSubstring?: string;
    skipDefaultValidation?: boolean;
}

export interface FiasSourceValue {
    convertationMethod?: fiasConvertationMethods;
    fiasApiPath?: string;
    autoValue?: string;
    postfix?: string;
    prefix?: string;
    onValueDontExist?: string;
    ifFiasApiDependExist?: string;
}

export enum FiasExtendFieldsType {
    string = "string",
    guid = "guid",
    kladr = "kladr",
    index = "index",
}

export interface FiasAddressFields {
    region?: FiasRegion;
    municipaldistrict?: FiasMunicipalDistrict;
    urbansettlement?: FiasUrbanSettlement;
    district?: FiasDistrict;
    city?: FiasCity;
    settlement?: FiasSettlement;
    planningstructure?: FiasPlanningStructure;
    street?: FiasStreet;
    stead?: FiasStead;
    garhouse?: FiasHouseGar;
    house?: FiasHouseGar;
    carplace?: FiasApartment;
    apartment?: FiasApartment;
    room?: FiasFlatRoom;
    suggest?: SuggestAddress;
}

export interface FiasCity {
    name: string;
    abbreviation: string;
    fiasId: Guid;
    actuality: boolean;
    id: string;
    parentFiasId: string;
    level: string;
    okato: string;
    oktmo: string;
    ifnsfl: string;
    ifnsul: string;
    code: string;
}

export interface FiasSettlement {
    name: string;
    abbreviation: string;
    fiasId: string;
    actuality: boolean;
    id: string;
    parentFiasId: string;
    level: string;
    okato: string;
    oktmo: string;
    ifnsfl: string;
    ifnsul: string;
    postalCode: string;
    code: string;
}

export interface FiasUrbanSettlement {
    name: string;
    abbreviation: string;
    fiasId: Guid;
    actuality: boolean;
    id: string;
    parentFiasId: string;
    level: string;
    oktmo: string;
}

export interface SuggestAddress {
    actualLevel: null | string;
    fiasId: string;
    fiasLevel: null | string;
    label: string;
    level: string;
    matchResult: string;
    value: string;
}

interface FiasDistrict {
    abbreviation: string;
    actuality: boolean;
    code: string;
    fiasId: string;
    id: string;
    ifnsfl: string;
    ifnsul: string;
    level: string;
    name: string;
    okato: string;
    oktmo: string;
}

export interface FiasStead {
    number: string;
    fiasId: string;
    parentFiasId: string;
    id: string;
    liveStatus: string;
    okato: string;
    oktmo: string;
    ifnsfl: string;
    ifnsul: string;
    cadastralNumber: string;
}

export interface FiasMunicipalDistrict {
    name: string;
    abbreviation: string;
    fiasId: Guid;
    actuality: boolean;
    id: string;
    parentFiasId: string;
    level: string;
    oktmo: string;
}

export interface FiasRegion {
    id: Guid;
    fiasId: Guid;
    name: string;
    abbreviation: string;
    nameWithAbbreviation: string;
    actuality: boolean;
    level: string;
    official: string;
    okato?: string;
    ifnsfl?: string;
    oktmo?: string;
    ifnsul?: string;
    postalCode?: string;
    code?: string;
}

export interface FiasStreet {
    name: string;
    abbreviation: string;
    fiasId: string;
    actuality: boolean;
    id: string;
    parentFiasId: string;
    level: string;
    okato: string;
    oktmo: string;
    ifnsfl: string;
    ifnsul: string;
    postalCode: string;
    code: string;
}

export interface FiasStead {
    number: string;
    fiasId: string;
    parentFiasId: string;
    id: string;
    liveStatus: string;
    okato: string;
    oktmo: string;
    ifnsfl: string;
    ifnsul: string;
    cadastralNumber: string;
}

export interface FiasPlanningStructure {
    name: string;
    abbreviation: string;
    fiasId: Guid;
    actuality: boolean;
    id: string;
    parentFiasId: string;
    level: string;
    okato: string;
    oktmo: string;
    ifnsfl: string;
    ifnsul: string;
    postalCode: string;
    code: string;
}

export interface FiasFlatRoom {
    flatNumber: string;
    flatType: number;
    fiasId: string;
    parentFiasId: string;
    id: string;
    liveStatus: string;
    flatFiasId: string;
    roomNumber: string;
    roomType: string;
}

export interface FiasHouseGar {
    buildingNumber: Boolean;
    houseNum: string;
    houseType: string;
    addNum1?: string;
    addType1?: string;
    addNum2?: string;
    addType2?: string;

    fiasId: string;
    parentFiasId: string;
    id: string;
    actuality: boolean;
    postalCode: string;
    okato: string;
    oktmo: string;
    ifnsfl: string;
    ifnsul: string;
}

export interface FiasApartment {
    flatNumber: string;
    flatType: number;
    fiasId: Guid;
    parentFiasId: string;
    id: string;
    liveStatus: "active" | "inactive";
    roomNumber: string;
    flatFiasId: string;
}

export interface FiasStead {
    number: string;
    fiasId: string;
    parentFiasId: string;
    id: string;
    liveStatus: string;
    okato: string;
    oktmo: string;
    ifnsfl: string;
    ifnsul: string;
    cadastralNumber: string;
}

export interface FiasCountry {
    code: string;
    fullName: string;
    shortName: string;
}

export type divisionType = "municipal" | "administrative";

export type addressLevels = keyof FiasAddressFields;

export interface FiasAddressType {
    code: string;
    level: AddressLevel;
    fullName: string;
    shortName: string;
}

export enum AddressLevel {
    Region = "Region",
    AutonomousCounty = "AutonomousCounty",
    District = "District",
    MunicipalDistrict = "MunicipalDistrict",
    UrbanSettlement = "UrbanSettlement",
    City = "City",
    IntracityArea = "IntracityArea",
    Settlement = "Settlement",
    PlanningStructure = "PlanningStructure",
    Street = "Street",
    Stead = "Stead",
    ExtraArea = "ExtraArea",
    ExtraAreaStreet = "ExtraAreaStreet",
    House = "House",
    Apartment = "Apartment",
    Room = "Room",
    FlatRoom = "FlatRoom",
    CarPlace = "CarPlace",
}
